import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Set flag to tell JumpPhotos to ignore this scroll
    window.__programmaticScroll = true;
    window.scrollTo(0, 0);
    // Clear flag after a short delay
    setTimeout(() => {
      window.__programmaticScroll = false;
    }, 100);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
